// ─────────────────────────────────────────────────────────────────────────────
// THE XERATEC TEAM — the one place to edit who is on the team.
//
// The About page roster and every team profile page read from this file.
//
// To ADD someone: copy one person block (from `{` to `},`), paste it into the
//   right group, and change the details.
// To REMOVE someone: delete their block. Their profile page keeps working
//   but stops being listed; to take the page down too, add its path to
//   content/removed.json.
// To REORDER: move blocks around; people show up in the order written here.
//
// Each person has:
//   name      What the team grid shows, e.g. "Steve H".
//   fullName  First and last name, shown as the heading of their profile page.
//   title     Their job title.
//   path      Address of their profile page (keep the slashes). New people:
//             "/team/first-last/". Their page is created automatically.
//             For people from the old site, profile text comes from the
//             captured page at this path unless `bio` is given.
//   photo     New people: "team/first-last.jpg" for a photo saved in
//             public/images/team/. People from the old site use the file name
//             it was uploaded under (in public/assets, after the
//             "xxxxxxxxxx-" prefix). Leave it out to show a letter avatar.
//   linkedin  Optional. Their LinkedIn profile address.
//   bio       Profile text (required for new people; for people from the old
//             site it replaces the captured text):
//             a list of { heading, text } sections. A section headed
//             "Fun fact", "Special skill" or "Secret weapon" shows as a card.
// ─────────────────────────────────────────────────────────────────────────────

export const teamGroups = [
  {
    name: "Leadership",
    people: [
      {
        name: "Steve H",
        fullName: "Steven Hillstrom",
        title: "Chief of Technology · Founder",
        path: "/steven-ceo/",
        photo: "IMG_3630-225x300.jpg",
        linkedin: "https://www.linkedin.com/in/stevenhillstrom/",
        bio: [
          {
            heading: "What he does",
            text: "Steve founded Xeratec and led it for over twenty years, growing it from a one-man business into a lively office with teammates across the country. These days he focuses on leading LoadTraxx and helping steer vision and growth for both companies.",
          },
          {
            heading: "Background",
            text: "While working warehousing and logistics at American Hospital Supply, Steve taught himself programming to make his own job easier — his software training literally started on a forklift at Baxter Healthcare. He went on to earn a BA in MIS from DePaul University, all with more than a handful of kids at home.",
          },
          {
            heading: "Off the clock",
            text: "A father of 16, Steve is a family man through and through. He loves traveling, scuba diving, ping pong, and golf — and the quiet that comes with hunting and fishing, even if he admits he's not very good at either.",
          },
          {
            heading: "Fun fact",
            text: "Steve has landed multiple contracts while stranded at O'Hare in winter storms. He has a knack for connecting with people in the wrong place at the right time.",
          },
        ],
      },
      {
        name: "Brett",
        fullName: "Brett Hillstrom",
        title: "Chief Executive Officer",
        path: "/brett-president/",
        photo: "DSC_1909-300x206.png",
        linkedin: "https://www.linkedin.com/in/brett-hilllstrom/",
        bio: [
          {
            heading: "What he does",
            text: "As Chief Executive Officer, Brett leads Xeratec's culture, business strategy, and strategic relationships — and still rolls up his sleeves to consult on software projects when a build needs direction.",
          },
          {
            heading: "Background",
            text: "Brett's first job was on a dairy farm in Wisconsin, where the work ethic stuck. After moving to Michigan, he became a USA Hockey official — leadership training with a whistle — and taught himself to program while working for his father's business, growing into the self-taught technology leader he is today.",
          },
          {
            heading: "Off the clock",
            text: "Brett is fueled by watching companies get aligned and moving forward — Xeratec's or anyone's. He also carries a plethora of dad jokes for any situation that needs defusing.",
          },
          {
            heading: "Fun fact",
            text: "He's commonly mistaken for Tom Holland — specifically Peter Parker. His secret weapon, in his own words: his team.",
          },
        ],
      },
      {
        name: "Jordan",
        fullName: "Jordan Hillstrom",
        title: "Sales and Marketing Manager",
        path: "/jordan-chief-revenue-officer/",
        photo: "IMG_422540-225x300.jpg",
        linkedin: "https://www.linkedin.com/in/jordan-hillstrom-525a98162/",
        bio: [
          {
            heading: "What he does",
            text: "As Sales and Marketing Manager, Jordan loves getting to know people and digging into the details of how their business runs — finding exactly where technology can improve efficiency, productivity, or profitability.",
          },
          {
            heading: "Background",
            text: "Jordan joined the military out of high school and fought his way into the 75th Ranger Regiment, deploying three times. After a degree in criminal justice and transportation logistics and five years with the Washington State Patrol, he moved into commercial construction — where he helped design and build a SaaS product for the dump truck industry and discovered he loved people, problems, and being on the team that solves them.",
          },
          {
            heading: "Off the clock",
            text: "Water fascinates Jordan — he'll stop a road trip to jump in a random lake. He also loves long, difficult hikes and challenging himself mentally and physically.",
          },
          {
            heading: "Fun fact",
            text: "Jordan once lit his backyard on fire attempting his first “trash-can turkey.” He has since perfected the trash-can turkey.",
          },
        ],
      },
      {
        name: "Jason",
        fullName: "Jason Branaugh",
        title: "Operations Manager",
        path: "/jason-operations-manager/",
        photo: "IMG_066297-225x300.png",
        linkedin: "https://www.linkedin.com/in/jason-branaugh-9b289a95/",
      },
    ],
  },
  {
    name: "Operations, Product & Sales",
    people: [
      {
        name: "Travis",
        fullName: "Travis Williams",
        title: "Product Owner",
        path: "/travis-product-owner/",
        photo: "IMG_4838-e1775844264347-214x300.jpg",
        linkedin: "https://www.linkedin.com/in/travis-williams-8574619a/",
      },
      {
        name: "Josie",
        fullName: "Josie Bender",
        title: "Sales Development Representative",
        path: "/josie-sales-development-representative/",
        photo:
          "Screenshot-2026-02-17-at-10.18.32-AM-e1775846319770-267x300.png",
        linkedin: "https://www.linkedin.com/in/josie-bender/",
      },
      {
        name: "Janie",
        fullName: "Janie Tormanen",
        title: "Office Administrator",
        path: "/travis-product-owner-2/",
        photo: "92DA3A7F-C405-440C-B7A1-843AAF3C0530_4_5005_c-225x300.jpeg",
        linkedin: "https://www.linkedin.com/in/janie-tormanen-981b8727a/",
      },
      {
        name: "Ross",
        fullName: "Ross Kinnunen",
        title: "LoadTraxx",
        path: "/ross-loadtraxx/",
        photo: "Ross-kinnunen-225x300.jpg",
        linkedin: "https://www.linkedin.com/in/ross-kinnunen-33a37b4a/",
      },
    ],
  },
  {
    name: "Engineering",
    people: [
      {
        name: "Michael",
        fullName: "Michael Bellmore",
        title: "Solutions Engineer",
        path: "/michael-development-manager/",
        photo: "IMG_1800-1-scaled-e1654616089909-192x300.jpg",
        linkedin: "https://www.linkedin.com/in/michael-bellmore-aa594713/",
        bio: [
          {
            heading: "Role",
            text: "As a Solutions Engineer, Michael has several responsibilities including providing a great customer experience by producing excellent solutions to meet customer needs, designing solutions with other team members and developers, and mentoring and offering direction to less experienced team members.",
          },
          {
            heading: "Career",
            text: "Michael started his schooling seeking a degree in biochemistry from the University of Texas at Austin, but along the way realized how much he missed working with technology and computers. This led him down his career path after switching his major and graduating with a Bachelor of Science degree in Computer Science.",
          },
          {
            heading: "Fuel",
            text: "Michael loves to solve problems and create solutions using technology, creativity, and precision. He is driven to fix things. He is excited about new features in programming technologies and more efficient ways of doing things.",
          },
          {
            heading: "Fun Fact",
            text: "Michael loves spending time outdoors. Whether it’s hiking, walking, playing softball or golf, working in the garden, camping, fishing, hunting, etc., as long he’s outside he’s happy.",
          },
          {
            heading: "Special Skill",
            text: "He is an excellent cook. He loves when people can appreciate and enjoy his food. Michael was even awarded a “Grillmaster” certificate at the office!",
          },
          {
            heading: "Secret Weapon",
            text: "Michael comes from a background with a diverse exposure to different industries due to work experience and family occupations. He has experiences related to construction, carpentry, healthcare, grocery, and food services to name a few. This understanding helps to facilitate his interactions with different unique customers to explore solutions as he strives to deliver the best possible customer experience.",
          },
        ],
      },
      {
        name: "Steve K",
        fullName: "Steve Kangas",
        title: "Solutions Engineer",
        path: "/steve-senior-sfotware-engineer/",
        photo: "IMG_3475-scaled-e1654699647575-217x300.jpg",
        linkedin: "https://www.linkedin.com/in/steven-kangas-08835213/",
        bio: [
          {
            heading: "Role",
            text: "As a Solutions Engineer, Steve leads development projects and mentors other developers.",
          },
          {
            heading: "Career",
            text: "Steve’s development career started in 1995 when he was working as a student at Michigan Tech University. Steve was hired by the Local Technical Assistance Program as a Software Engineer and helped to develop a roadway management system using GIS technology which was in its early commercial stages. Steve continued in this role for 11 years before joining Xeratec as a Senior Software Engineer in 2006.",
          },
          {
            heading: "Fuel",
            text: "Although Steve considers himself a dinosaur, he still likes to learn new frameworks, new technologies, and new concepts. Steve also likes to dust off his older technology shoes once in a while. Steve says that combining these two things is what he really enjoys. He likes to take a concept written in an older technology and bring it into the present.",
          },
          {
            heading: "Fun Fact",
            text: "Steve started his work career at 14 years old as a tour guide for the Arcadian Copper Mine. He wasn’t old enough for a driver’s license so he had to ride a moped 9 miles to work after school. Uphill. Both ways. Being a tour guide at such a young age gave him the beginnings of the communication skills he would need in his professional career.",
          },
          {
            heading: "Special Skill",
            text: "Steve does a mean version of Froggy Been A-Courtin and he did ride uh-huh.",
          },
          {
            heading: "Secret Weapon",
            text: "Steve’s secret weapon is very impressive. But if he told you, it wouldn’t be secret anymore.",
          },
        ],
      },
      {
        name: "Joe",
        fullName: "Joe Wood",
        title: "Solutions Engineer",
        path: "/joe-software-engineer/",
        photo: "Joe-Wood-242x300.jpg",
        linkedin: "https://www.linkedin.com/in/joseph-wood-5315491aa/",
        bio: [
          {
            heading: "Role",
            text: "As a Solutions Engineer, Joe Wood is responsible for implementing crucial features across a wide range of projects. His work ensures that our products not only meet but exceed customer expectations.",
          },
          {
            heading: "Career",
            text: "Joe grew up in Houghton, MI, just across the canal from our home office. He embarked on his educational journey by enrolling at the local University. Throughout his time at Michigan Tech, Joe dedicated himself to mastering the intricacies of computer science, laying the foundation for his career.",
          },
          {
            heading: "Fuel",
            text: "Fueled by a relentless passion for learning new things, Joe finds satisfaction in witnessing continuous improvement in his craft. Each day, he embraces the opportunity to expand his skillset, adapt to emerging technologies, and refine his expertise. His unwavering commitment to personal and professional growth keeps Joe on a perpetual path of self-improvement.",
          },
          {
            heading: "Fun Fact",
            text: "Joe has a unique ability to ride a unicycle. It’s not just a quirky skill; it’s a testament to his determination and willingness to take on unconventional challenges!",
          },
          {
            heading: "Special Skill",
            text: "A valuable attribute of Joe’s is his innate open-mindedness when it comes to embracing new ideas and perspectives presented by others. It’s a strength to be receptive and welcoming to diverse viewpoints, as it fosters a collaborative and inclusive environment where innovation thrives. This openness is a tremendous asset in problem-solving and teamwork.",
          },
          {
            heading: "Secret Weapon",
            text: "Joe’s secret weapon is his ‘flow state.’ In this unique mental zone, all distractions fade into the background, and he is able to channel his complete focus and energy into a single task. Time slows down, and productivity and creativity soar to their peak!",
          },
        ],
      },
      {
        name: "Tylor",
        fullName: "Tylor Hanshaw",
        title: "Solutions Engineer",
        path: "/tylor-software-engineer/",
        photo: "Work_Photo_218-242x300.jpg",
        linkedin: "https://www.linkedin.com/in/tylor-hanshaw/",
        bio: [
          {
            heading: "Role",
            text: "Tylor is a Solutions Engineer at Xeratec Software Development, working as a full-stack developer. He helps end-to-end starting with what the user sees (the UI), all the way to the backend, ensuring that all data is stored securely.",
          },
          {
            heading: "Career",
            text: "He went to school and graduated from Northern Michigan University with a Bachelor’s degree majoring in Mobile App and Web Development. Software development ran in Tylor’s family when his dad began his career as a software developer around the time Tylor was born. He was always around technology in some fashion growing up. When Tylor first started attending Northern Michigan University he wanted to originally branch out away from computer science and technology so he chose to major in Biology with a focus in Mycology. Tylor ended up taking an Intro to Web Development course as a general education course and that class is what re-sparked his love for problem-solving and technology overall. He switched majors shortly after completing that course and as they say, “the rest is history”. Since graduating Tylor has worked as a federal government contractor doing mobile app development for both Android and iOS devices, and full-stack development for local clients.",
          },
          {
            heading: "Fuel",
            text: "The unknown is what excites Tylor. When he’s given a task or bug to fix and not 100% sure how to tackle it, this is when the gears start going for him. He thinks, “There has to be a solution, there’s got to be a way to solve this problem”. This is one of the reasons why Tylor loves software development! It’s like a maze from start to end where the end of the maze is working and bug-free software! Outside of software development, Tylor tries to spend most of his time in nature. He loves to camp, mountain bike, and travel. After spending time solving problems he looks forward to going outside and getting some fresh air.",
          },
          {
            heading: "Fun Fact",
            text: "When Tylor was attending Northern Michigan University one winter semester he tried to winter surf just off the coast of Presque Isle in Marquette, MI. He can now say that I’m not very good at surfing let alone winter surfing, but he came back with a cool-looking icicle beard!",
          },
          {
            heading: "Special Skill",
            text: "His special skill relating to software development is that he can pick up new languages very quickly. Tylor tries to play with new programming languages when he has time and after doing this for a few years it’s become fairly easy for him to pick up new languages and the common patterns used by them. Outside of software development his special skill is his running abilities. In high school Tylor was in track with main events being the 100, 200, 400 meter dash as well as the 4×1 event with three other team members. His 4×1 team set a school record. Tylor may not run competitively anymore but he still enjoys de-stressing with a run a few times a week.",
          },
          {
            heading: "Secret Weapon",
            text: "Thinking outside of the box, when given a new problem or put on a new project. Tylor likes to look at issues from a different perspective. This allows him and others he’s working with to break patterns that may have dug holes in the past and allow them to solve issues quicker and more creatively.",
          },
        ],
      },
      {
        name: "Carl",
        fullName: "Carl Asiala",
        title: "Solutions Engineer",
        path: "/carl-software-engineer/",
        photo: "IMG_8969-225x300.jpg",
        linkedin: "https://www.linkedin.com/in/carl-asiala-552b54145/",
      },
      {
        name: "Nathan",
        fullName: "Nathan Fisher",
        title: "Solutions Engineer",
        path: "/nathan-software-engineer/",
        photo: "IMG_3673-scaled-e1654795559388-237x300.jpg",
        linkedin: "https://www.linkedin.com/in/nathan-fisher-275879223/",
      },
      {
        name: "Patrick",
        fullName: "Patrick Seidel",
        title: "Solutions Engineer",
        path: "/patrick-software-engineer/",
        photo: "IMG_1375-1-225x300.jpg",
        linkedin: "https://www.linkedin.com/in/patrick-seidel-381152274/",
        bio: [
          {
            heading: "Role",
            text: "Patrick is a talented Solutions Engineer at Xeratec Software Development. He plays a crucial role in the development and timely delivery of our projects.",
          },
          {
            heading: "Career",
            text: "While attending Michigan Technological University, Patrick secured an internship with Xeratec during his final semester. He graduated in the Spring of 2023 with a Bachelor’s degree in Software Engineering and a Minor in Mathematical Sciences. Patrick was ready to jump right into projects on a larger scale and has been a huge asset to the Xeratec team.",
          },
          {
            heading: "Fuel",
            text: "Patrick is a true outdoors enthusiast. Hailing from southern Michigan, he developed a deep affection for the Keweenaw region during his time at the local university. When he’s not excelling in his work, you’ll often find Patrick on the golf course, hiking trails, swimming in Lake Superior, or carving up the slopes during the winter months. His passion for outdoor activities fuels his zest for life.",
          },
          {
            heading: "Fun Fact",
            text: "Patrick stands out as the tallest member of our team at Xeratec Software Development. During our first encounter with him at the Michigan Tech University Career Fair, he was easily noticeable in photos, effortlessly towering over the rest of the Xeratec staff.",
          },
          {
            heading: "Special Skill",
            text: "Patrick is an exceptionally fast learner who embodies the essence of our core value “figureoutable.” His ability to quickly grasp new concepts and adapt to challenging situations is truly remarkable.",
          },
          {
            heading: "Secret Weapon",
            text: "His secret weapon is his unwavering ability to find solutions to any problem he encounters. With determination and perseverance, he tackles challenges head-on, never backing down until he delivers the desired outcome.",
          },
        ],
      },
      {
        name: "Kyler",
        fullName: "Kyler Hillstrom",
        title: "Solutions Engineer",
        path: "/kyler-intern/",
        photo: "FullSizeRender-2-246x300.jpeg",
        linkedin: "https://www.linkedin.com/in/kyler-hillstrom-b02b6025a/",
        bio: [
          {
            heading: "Role",
            text: "As a Solutions Engineer, Kyler builds software for Xeratec’s clients, taking features from first idea through testing and delivery. His knack for debugging helps him track down problems quickly, so the tools our customers rely on stay dependable.",
          },
          {
            heading: "Career",
            text: "Kyler is a dedicated student pursuing his education at Michigan Technological University. His journey into the world of technology took an interesting turn after initially pursuing a different degree in college. Realizing his passion lay elsewhere, Kyler decided to take a pause and explore his interests further. Through self-guided learning and diligent research, he discovered his knack for coding, drawn by the intricate workings behind the screen. Now, Kyler is thrilled to be part of our team, where he learns and grows alongside seasoned Senior Developers, gaining invaluable real-world experience as he progresses toward his degree in Software Engineering.",
          },
          {
            heading: "Fuel",
            text: "Like many developers, Kyler finds genuine thrill in troubleshooting and solving problems. Each successful resolution not only fuels his excitement but also strengthens his confidence in the gratifying nature of this profession.",
          },
          {
            heading: "Fun Fact",
            text: "Kyler harbors a dream of one day designing his own video game. The allure of game design first captivated his interest during his exploration of various career paths.",
          },
          {
            heading: "Special Skill",
            text: "Kyler catches on very quickly. Once he learns something, he can apply it. This innate skill enables him to adapt and excel in various tasks, contributing to his effectiveness and success in both academic and professional endeavors.",
          },
          {
            heading: "Secret Weapon",
            text: "Kyler’s secret weapon is his ability to connect the dots quickly. He spots how ideas, problems and people fit together, then turns those connections into a clear plan the team can act on.",
          },
        ],
      },
      {
        name: "Noah",
        fullName: "Noah Zabinski",
        title: "Solutions Engineer Intern",
        path: "/team/noah-zabinski/",
        photo: "team/noah-zabinski.jpg",
        linkedin: "https://www.linkedin.com/in/noahzabinski/",
        bio: [
          {
            heading: "Role",
            text: "As a Solutions Engineer Intern at Xeratec, Noah is building his skills in web development by working alongside the team on real projects. He pitches in on development and testing, learning how software comes together from the engineers around him. Each project gives him hands-on experience he carries back to the classroom and into his career.",
          },
          {
            heading: "Career",
            text: "Noah is a third-year student at Michigan Technological University, majoring in Software Engineering with a minor in Cybersecurity. Originally from Michigan’s Lower Peninsula, he has come to favor the U.P. since moving to Houghton for school. While living in the area, Noah has followed Xeratec’s work, so joining the team as a web development intern was an easy choice. He’s excited to learn from the team, grow as a developer, and contribute to real projects as he works toward his degree.",
          },
          {
            heading: "Fuel",
            text: "Noah is driven by the chance to build tools that make a real difference in people’s daily lives. He enjoys finding ways to modernize older processes and make someone’s job a little easier, and he values the real-world experience that comes with each project. Away from the keyboard, you’ll find Noah on the golf course in the summer, skiing the slopes of Mount Bohemia in the winter, or cliff jumping whenever he gets the chance.",
          },
          {
            heading: "Fun fact",
            text: "In the age of streaming, Noah still collects music CDs. His shelf leans heavily toward classic rock, especially the Eagles and Michigan’s own Bob Seger.",
          },
          {
            heading: "Special skill",
            text: "Noah has been powerlifting since high school, competing all four years and continuing to train through college. The discipline and consistency it takes under the bar carry over into how he approaches his work.",
          },
          {
            heading: "Secret weapon",
            text: "“If you’re going to do something, do it right.” It’s a lesson from his dad that Noah applies to every line of code he writes.",
          },
        ],
      },
    ],
  },
];

// ── Helpers (no need to edit below this line) ───────────────────────────────

/** Everyone on the roster, in order, each tagged with their group name. */
export const team = teamGroups.flatMap((group) =>
  group.people.map((person) => ({ ...person, group: group.name })),
);

/** The roster entry whose profile lives at `path`, if any. */
export const teamMemberAt = (path) =>
  team.find((person) => person.path === path);
